/* GMapSelectorBuilder -- builds rectangle selector for Google Map */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {

  var DOT_CSS = 'position:absolute;width:10px;height:10px;background:#fff;border:2px solid #444;border-radius:50%;box-sizing:border-box;transform:translate(-50%,-50%);pointer-events:none;';

  function makeDiv() {
    var div = document.createElement('div');
    div.style.cssText = DOT_CSS;
    return div;
  }

  function DotMarker(latLng, map) {
    this.latLng_ = latLng;
    this.divs_ = [];
    this.setMap(map);
  }
  DotMarker.prototype = Object.create(google.maps.OverlayView.prototype);
  DotMarker.prototype.constructor = DotMarker;
  DotMarker.prototype.onAdd = function () {
    var div = makeDiv();
    this.divs_ = [div];
    this.getPanes().overlayMouseTarget.appendChild(div);
  };
  DotMarker.prototype.draw = function () {
    if (this.divs_.length === 0) { return; }
    var point = this.getProjection().fromLatLngToDivPixel(this.latLng_);
    if (!point) { return; }
    var map = this.getMap();
    var zoom = map ? map.getZoom() : undefined;
    var mapDiv = map ? map.getDiv() : null;
    var panes = this.getPanes();
    if (zoom === undefined || !mapDiv || !panes) {
      this.divs_[0].style.left = point.x + 'px';
      this.divs_[0].style.top = point.y + 'px';
      for (var h = 1; h < this.divs_.length; h++) { this.divs_[h].style.display = 'none'; }
      return;
    }
    var worldWidthPx = 256 * Math.pow(2, zoom);
    var containerWidth = mapDiv.getBoundingClientRect().width;
    if (containerWidth <= 0 || worldWidthPx <= 0) {
      this.divs_[0].style.left = point.x + 'px';
      this.divs_[0].style.top = point.y + 'px';
      return;
    }
    var containerPoint = this.getProjection().fromLatLngToContainerPixel(this.latLng_);
    var xs = [];
    var startN = Math.floor(-containerPoint.x / worldWidthPx);
    var endN = Math.ceil((containerWidth - containerPoint.x) / worldWidthPx);
    for (var n = startN; n <= endN; n++) {
      var containerX = containerPoint.x + n * worldWidthPx;
      if (containerX >= -5 && containerX <= containerWidth + 5) { xs.push(point.x + n * worldWidthPx); }
    }
    if (xs.length === 0) { xs.push(point.x); }
    var self = this;
    while (self.divs_.length < xs.length) {
      var newDiv = makeDiv();
      panes.overlayMouseTarget.appendChild(newDiv);
      self.divs_.push(newDiv);
    }
    for (var i = 0; i < this.divs_.length; i++) {
      if (i < xs.length) {
        this.divs_[i].style.display = '';
        this.divs_[i].style.left = xs[i] + 'px';
        this.divs_[i].style.top = point.y + 'px';
      } else {
        this.divs_[i].style.display = 'none';
      }
    }
  };
  DotMarker.prototype.onRemove = function () {
    this.divs_.forEach(function (div) {
      if (div.parentNode) { div.parentNode.removeChild(div); }
    });
    this.divs_ = [];
  };
  DotMarker.prototype.setPosition = function (latLng) {
    this.latLng_ = latLng;
    this.draw();
  };

  function getMidpoints(sw, ne) {
    var midLat = (sw.lat() + ne.lat()) / 2;
    var midLng = (sw.lng() + ne.lng()) / 2;
    return [
      new google.maps.LatLng(ne.lat(), midLng),
      new google.maps.LatLng(sw.lat(), midLng),
      new google.maps.LatLng(midLat, sw.lng()),
      new google.maps.LatLng(midLat, ne.lng()),
    ];
  }

  function isClickOnMapControl(e) {
    var controls = document.querySelectorAll('.map_selector, .map_ruler, .map_delete_rectangle');
    for (var i = 0; i < controls.length; i++) {
      var rect = controls[i].getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX <= rect.right &&
          e.clientY >= rect.top && e.clientY <= rect.bottom) {
        return true;
      }
    }
    return false;
  }

  var SELECT_RECTANGLE_IMG = require('images/select_rectangle.svg');
  var SELECTED_RECTANGLE_IMG = require('images/selected_rectangle.svg');

  function GMapSelector(gMap, rectangleChangedListener, activationCallback) {
    this.RECTANGLE_OPTIONS = {
      strokeWeight: 0,
      fillOpacity: 0.4,
      editable: false,
      draggable: false,
      fillColor: '#D78825',
      strokeColor: '#D78825',
    };
    this.selectedPolygon = null;
    this.gMap = gMap;
    this.rectangleChangedListener = rectangleChangedListener;
    this.activationCallback = activationCallback || null;

    this.drawingActive = false;
    this.startLatLng = null;
    this.clickListener = null;
    this.finalClickListener = null;
    this.mousemoveListener = null;
    this.cornerDots = [];
    this.midpointDots = [];
    this.rectangleVisible = true;

    this.selectorButton = null;
    this.selectorImg = null;
  }

  GMapSelector.prototype.addDrawingUi = function (container) {
    var self = this;

    // Selector (draw rectangle) button
    var mapSelectorControl = $.parseHTML("<div class='map_selector'></div>");
    $(mapSelectorControl[0]).prop('title', I18n.t('globals.gmap.selector_icon_tooltip'));
    mapSelectorControl[0].addEventListener('click', function () {
      if (self.drawingActive) {
        self.stopDrawing();
      } else if (self.selectedPolygon) {
        self.toggleVisibility();
      } else {
        self.startDrawing();
      }
    });

    self.selectorImg = $.parseHTML("<img src=\"" + SELECT_RECTANGLE_IMG + "\"/>")[0];
    self.selectorButton = $.parseHTML("<div id='map_selector_button'></div>")[0];
    self.selectorButton.appendChild(self.selectorImg);
    mapSelectorControl[0].appendChild(self.selectorButton);

    // Delete (trash) button — placed in the same wrapper so no inter-control gap
    var mapDeleteButton = $.parseHTML("<div class='map_delete_rectangle'></div>")[0];
    $(mapDeleteButton).prop('title', I18n.t("globals.gmap.garbage_icon_tooltip"));
    mapDeleteButton.addEventListener('click', function () {
      self.rectangleChangedListener(null);
      self.deleteRectangle();
    });
    var mapDeleteImage = $.parseHTML("<div>" + GMapUtil.imageTagTrash() + "</div>")[0];
    mapDeleteButton.appendChild(mapDeleteImage);

    if (container) {
      container.appendChild(mapSelectorControl[0]);
      container.appendChild(mapDeleteButton);
    } else {
      var mapCenterControl = $.parseHTML("<div></div>");
      mapCenterControl[0].index = 1;
      mapCenterControl[0].appendChild(mapSelectorControl[0]);
      mapCenterControl[0].appendChild(mapDeleteButton);
      self.gMap.map().controls[google.maps.ControlPosition.LEFT_CENTER].push(mapCenterControl[0]);
    }
  };

  GMapSelector.prototype.startDrawing = function () {
    var self = this;

    if (self.activationCallback) {
      self.activationCallback();
    }

    self.drawingActive = true;
    self.selectorButton.classList.add('active');
    self.gMap.map().setOptions({ draggableCursor: 'crosshair', draggable: false, gestureHandling: 'greedy' });

    var mapDiv = self.gMap.map().getDiv();

    // Transparent overlay above all map layers so draw handlers capture events
    // even when the cursor is over markers or other clickable overlays.
    var captureDiv = document.createElement('div');
    captureDiv.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999;cursor:crosshair;';
    mapDiv.appendChild(captureDiv);
    self._captureDiv = captureDiv;

    var dragging = false;
    var mouseDownLatLng = null;
    var firstClickLatLng = null;

    // Helper: convert pixel event to LatLng using the map's projection.
    // Uses center + scale formula: correct at all zoom levels including
    // full zoom-out where getBounds() world-wrap causes width to collapse.
    function eventToLatLng(e) {
      var projection = self.gMap.map().getProjection();
      var center = projection.fromLatLngToPoint(self.gMap.map().getCenter());
      var scale = Math.pow(2, self.gMap.map().getZoom());
      var mapRect = mapDiv.getBoundingClientRect();
      var x = Math.max(0, Math.min(e.clientX - mapRect.left, mapRect.width));
      var y = Math.max(0, Math.min(e.clientY - mapRect.top, mapRect.height));
      var worldPoint = new google.maps.Point(
        center.x + (x - mapRect.width  / 2) / scale,
        center.y + (y - mapRect.height / 2) / scale
      );
      return projection.fromPointToLatLng(worldPoint);
    }

    function beginPreview(latLng) {
      self.startLatLng = latLng;
      if (self.selectedPolygon) {
        self.selectedPolygon.setMap(null);
        self.selectedPolygon = null;
      }
      self.removeAllDots();

      self.selectedPolygon = new google.maps.Rectangle($.extend({}, self.RECTANGLE_OPTIONS, {
        map: self.gMap.map(),
        bounds: new google.maps.LatLngBounds(self.startLatLng, self.startLatLng),
        clickable: false
      }));
      self.createCornerDots(self.startLatLng, self.startLatLng);
      self.createMidpointDots(self.startLatLng, self.startLatLng);
    }

    function updatePreview(latLng) {
      if (!self.selectedPolygon || !self.startLatLng) { return; }
      var sw = new google.maps.LatLng(
        Math.min(self.startLatLng.lat(), latLng.lat()),
        Math.min(self.startLatLng.lng(), latLng.lng())
      );
      var ne = new google.maps.LatLng(
        Math.max(self.startLatLng.lat(), latLng.lat()),
        Math.max(self.startLatLng.lng(), latLng.lng())
      );
      var bounds = new google.maps.LatLngBounds(sw, ne);
      self.selectedPolygon.setBounds(bounds);
      self.updateCornerDots(sw, ne);
      self.updateMidpointDots(sw, ne);
      self.rectangleChangedListener(bounds);
    }

    self._mousedownHandler = function (e) {
      if (e.button !== 0) { return; }
      if (isClickOnMapControl(e)) { return; }
      dragging = false;
      mouseDownLatLng = eventToLatLng(e);
    };

    self._mousemoveHandler = function (e) {
      var currentLatLng = eventToLatLng(e);
      if (mouseDownLatLng && !dragging) {
        dragging = true;
        beginPreview(mouseDownLatLng);
        firstClickLatLng = null;
      }
      if (dragging || firstClickLatLng) {
        updatePreview(currentLatLng);
      }
    };

    self._mouseupHandler = function (e) {
      if (e.button !== 0) { return; }
      var upLatLng = eventToLatLng(e);
      if (dragging) {
        dragging = false;
        mouseDownLatLng = null;
        self.finishDrawing(upLatLng);
      } else if (mouseDownLatLng) {
        if (!firstClickLatLng) {
          firstClickLatLng = upLatLng;
          mouseDownLatLng = null;
          beginPreview(firstClickLatLng);
        } else {
          var second = upLatLng;
          mouseDownLatLng = null;
          firstClickLatLng = null;
          self.finishDrawing(second);
        }
      }
    };

    captureDiv.addEventListener('mousedown', self._mousedownHandler);
    captureDiv.addEventListener('mousemove', self._mousemoveHandler);
    captureDiv.addEventListener('mouseup', self._mouseupHandler);
  };

  GMapSelector.prototype.finishDrawing = function (finalLatLng) {
    var self = this;

    if (self.mousemoveListener) {
      google.maps.event.removeListener(self.mousemoveListener);
      self.mousemoveListener = null;
    }

    var startLatLng = self.startLatLng;
    self.stopDrawing(true);

    var sw = new google.maps.LatLng(
      Math.min(startLatLng.lat(), finalLatLng.lat()),
      Math.min(startLatLng.lng(), finalLatLng.lng())
    );
    var ne = new google.maps.LatLng(
      Math.max(startLatLng.lat(), finalLatLng.lat()),
      Math.max(startLatLng.lng(), finalLatLng.lng())
    );
    var finalBounds = new google.maps.LatLngBounds(sw, ne);

    self.selectedPolygon.setBounds(finalBounds);
    self.selectedPolygon.setOptions({ editable: true, draggable: true, clickable: true });
    self.updateCornerDots(sw, ne);
    self.updateMidpointDots(sw, ne);
    self.addBoundsChangedListener(self.selectedPolygon, self.rectangleChangedListener);
    self.rectangleChangedListener(finalBounds);
    self.updateSelectorIcon(true);
  };

  GMapSelector.prototype.stopDrawing = function (keepRectangle) {
    var self = this;
    self.drawingActive = false;
    self.selectorButton.classList.remove('active');
    self.gMap.map().setOptions({ draggableCursor: null, draggable: true, gestureHandling: 'auto' });

    if (self._captureDiv) {
      if (self._mousedownHandler) { self._captureDiv.removeEventListener('mousedown', self._mousedownHandler); }
      if (self._mousemoveHandler) { self._captureDiv.removeEventListener('mousemove', self._mousemoveHandler); }
      if (self._mouseupHandler) { self._captureDiv.removeEventListener('mouseup', self._mouseupHandler); }
      if (self._captureDiv.parentNode) { self._captureDiv.parentNode.removeChild(self._captureDiv); }
      self._captureDiv = null;
    }
    self._mousedownHandler = null;
    self._mousemoveHandler = null;
    self._mouseupHandler = null;

    // If cancelled mid-draw (not finishing), remove the preview rectangle and dots
    if (!keepRectangle && self.startLatLng && self.selectedPolygon) {
      self.selectedPolygon.setMap(null);
      self.selectedPolygon = null;
      self.removeAllDots();
      self.rectangleChangedListener(null);
    }
    self.startLatLng = null;
  };

  GMapSelector.prototype.createCornerDots = function (sw, ne) {
    var self = this;
    var map = self.gMap.map();
    var positions = [
      new google.maps.LatLng(sw.lat(), sw.lng()),
      new google.maps.LatLng(sw.lat(), ne.lng()),
      new google.maps.LatLng(ne.lat(), sw.lng()),
      new google.maps.LatLng(ne.lat(), ne.lng()),
    ];
    positions.forEach(function (position) {
      self.cornerDots.push(new DotMarker(position, map));
    });
  };

  GMapSelector.prototype.updateCornerDots = function (sw, ne) {
    var positions = [
      new google.maps.LatLng(sw.lat(), sw.lng()),
      new google.maps.LatLng(sw.lat(), ne.lng()),
      new google.maps.LatLng(ne.lat(), sw.lng()),
      new google.maps.LatLng(ne.lat(), ne.lng()),
    ];
    for (var i = 0; i < this.cornerDots.length; i++) {
      this.cornerDots[i].setPosition(positions[i]);
    }
  };

  GMapSelector.prototype.removeCornerDots = function () {
    this.cornerDots.forEach(function (dot) { dot.setMap(null); });
    this.cornerDots = [];
  };

  GMapSelector.prototype.createMidpointDots = function (sw, ne) {
    var self = this;
    var map = self.gMap.map();
    getMidpoints(sw, ne).forEach(function (position) {
      self.midpointDots.push(new DotMarker(position, map));
    });
  };

  GMapSelector.prototype.updateMidpointDots = function (sw, ne) {
    var positions = getMidpoints(sw, ne);
    for (var i = 0; i < this.midpointDots.length; i++) {
      this.midpointDots[i].setPosition(positions[i]);
    }
  };

  GMapSelector.prototype.removeMidpointDots = function () {
    this.midpointDots.forEach(function (dot) { dot.setMap(null); });
    this.midpointDots = [];
  };

  GMapSelector.prototype.removeAllDots = function () {
    this.removeCornerDots();
    this.removeMidpointDots();
  };

  GMapSelector.prototype.updateSelectorIcon = function (hasRectangle) {
    if (this.selectorImg) {
      this.selectorImg.src = hasRectangle ? SELECTED_RECTANGLE_IMG : SELECT_RECTANGLE_IMG;
    }
    if (this.selectorButton) {
      if (hasRectangle) {
        this.selectorButton.classList.add('showing');
      } else {
        this.selectorButton.classList.remove('showing');
      }
    }
  };

  GMapSelector.prototype.addBoundsChangedListener = function (rectangle, listener) {
    var self = this;
    google.maps.event.addListener(rectangle, 'bounds_changed', function () {
      var bounds = rectangle.getBounds();
      listener(bounds);
      var sw = bounds.getSouthWest();
      var ne = bounds.getNorthEast();
      self.updateCornerDots(sw, ne);
      self.updateMidpointDots(sw, ne);
    });
  };

  GMapSelector.prototype.toggleVisibility = function () {
    if (this.rectangleVisible) {
      this.hideRectangle();
    } else {
      this.showRectangle();
    }
  };

  GMapSelector.prototype.hideRectangle = function () {
    this.rectangleVisible = false;
    if (this.selectedPolygon) {
      this.selectedPolygon.setMap(null);
    }
    this.cornerDots.forEach(function (dot) { dot.setMap(null); });
    this.midpointDots.forEach(function (dot) { dot.setMap(null); });
    if (this.selectorButton) { this.selectorButton.classList.remove('showing'); }
  };

  GMapSelector.prototype.showRectangle = function () {
    var map = this.gMap.map();
    this.rectangleVisible = true;
    if (this.selectedPolygon) {
      this.selectedPolygon.setMap(map);
    }
    this.cornerDots.forEach(function (dot) { dot.setMap(map); });
    this.midpointDots.forEach(function (dot) { dot.setMap(map); });
    if (this.selectorButton) { this.selectorButton.classList.add('showing'); }
  };

  GMapSelector.prototype.deleteRectangle = function () {
    if (this.selectedPolygon) {
      this.selectedPolygon.setMap(null);
      this.selectedPolygon = null;
    }
    this.removeAllDots();
    this.rectangleVisible = true;
    this.updateSelectorIcon(false);
  };

  GMapSelector.prototype.updateRectangle = function (minLatitude, minLongitude, maxLatitude, maxLongitude) {
    var southWest = new google.maps.LatLng(minLatitude, minLongitude);
    var northEast = new google.maps.LatLng(maxLatitude, maxLongitude);

    if (this.selectedPolygon) {
      this.selectedPolygon.setMap(null);
    }
    this.removeAllDots();

    this.selectedPolygon = new google.maps.Rectangle($.extend({}, this.RECTANGLE_OPTIONS, {
      map: this.gMap.map(),
      bounds: new google.maps.LatLngBounds(southWest, northEast),
      editable: true,
      draggable: true,
    }));
    this.createCornerDots(southWest, northEast);
    this.createMidpointDots(southWest, northEast);
    this.addBoundsChangedListener(this.selectedPolygon, this.rectangleChangedListener);
    this.updateSelectorIcon(true);
  };

  // No-op: kept for API compatibility
  GMapSelector.prototype.hideDrawingModes = function () { };

  return function (gMap, rectangleChangedListener, activationCallback, container) {
    if (!gMap.map()) {
      throw new Error("gMap must be initialized (setupMap called) before adding the selector controls");
    }
    var gMapSelector = new GMapSelector(gMap, rectangleChangedListener, activationCallback);
    gMapSelector.addDrawingUi(container);
    return gMapSelector;
  };
}));
